import { Backdrop, Box, Button, Checkbox, Chip, CircularProgress, Divider, MenuItem, Select, Typography } from "@mui/material"
import { useEffect, useMemo, useState } from "react";
import { DataGrid } from '@mui/x-data-grid';
import usersService from "../../services/usersService";
import RolloutService from "../../services/rolloutService/rolloutService"
import AlertSnackbar from "../../components/AlertSnackbar";
import TextInputComponent from "../../components/TextInputComponent";

const featureList = [
  { label: 'AI Calendar', value: 'AI_CALENDAR' },
  { label: 'AI Chat Bot', value: 'chat-bot' },
  { label: 'Set Leads By 10% in DW', value: 'SET_LEADS_STEP_10%' },
  // { label: 'Wait Time For Next Task in DW', value: 'WAIT_TIME_FOR_NEXT_TASK_DW' },
  // { label: 'DW Wait Time Configuration Form', value: 'DW_WAIT_TIME_CONFIG_FORM' },
  { label: 'Mass Leave Groups', value: 'MASS_LEAVE_GROUPS' },
];
const RolloutFeaturePage = () => {
  const [selectedOption, setSelectedOption] = useState(featureList[0].value);
  const [usersList, setUsersList] = useState([]);
  const [TotalusersList, setTotalUsersList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [settingType, setSettingType] = useState(null);
  const [disableCheckboxColumn, setDisableCheckboxColumn] = useState(true);
  const [disableSave, setDisableSave] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [selectedIds, setSelectedIds] = useState([]);
  const [search, setSearch] = useState("");
  const [currentSettingStatus,setCurrentSettingStatus] = useState("");
  console.log("selectedIds",selectedIds)
  const handleCheckboxChange = (id) => {
    setDisableSave(false);
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };
  let settingStatus = "";
  if (currentSettingStatus === "enabled") {
    settingStatus = "Enabled For all";
  } else if (currentSettingStatus === "disabled") {
    settingStatus = "Disabled For All";
  } else if (currentSettingStatus === "selectedUsers") { 
    settingStatus = "Enabled For Selected Users";
  }
  const columns = useMemo(() => {
    return [
      {
        field: 'selected',
        headerName: 'Select',
        type: 'boolean',
        width: 100,
        sortable: true,
        renderCell: (params) => (
          <Checkbox
            disabled={disableCheckboxColumn}
            sx={{ padding: '0px' }}
            checked={selectedIds.includes(params?.row.userId)}
            onChange={() => handleCheckboxChange(params?.row.userId)}
            inputProps={{ 'aria-label': 'select user' }}
          />
        ),
        valueGetter: (params) => selectedIds.includes(params?.row.id),
        sortComparator: (v1, v2, params1, params2) => {
          const isSelected1 = selectedIds.includes(params1.id);
          const isSelected2 = selectedIds.includes(params2.id);
          return isSelected1 === isSelected2 ? 0 : isSelected1 ? -1 : 1;
        },
      },
      {
        field: 'name',
        headerName: "Name",
        width: 250,
        valueGetter: (params) => params?.trim()
      }, {
        field: 'email',
        headerName: "Email ID",
        width: 250,
        valueGetter: (params) => params?.trim()
      }, {
        field: 'facebookUserName',
        headerName: "Facebook Username",
        width: 300,
        valueGetter: (params) => params?.trim()
      }, {
        field: 'status',
        headerName: "Status",
        width: 200,
        renderCell: (params) => {
          return (
            <Chip
              label={params.value.charAt(0).toUpperCase() + params.value.slice(1)}
              style={{
                backgroundColor: "#e6f7ed",
                color: "#1e4e31",
                padding: "1px 5px",
                fontWeight: "500",
              }}
              size="small"
            />
          );
        },
      },

    ];
  }, [disableCheckboxColumn,selectedIds]);
  
 

  const fetchRolloutSettings = async () => {
    try {
      setIsLoading(true);
      const params = { featureName: selectedOption }
      const resp = await RolloutService.getRolloutSettings(params);
      const rolloutSettings = resp?.data?.data
      if (rolloutSettings) {
        setSelectedIds(rolloutSettings.featureRolloutUsers)
        setSettingType(rolloutSettings.status);
        setCurrentSettingStatus(rolloutSettings.status);
        if (rolloutSettings.status === "selectedUsers") {
          setDisableCheckboxColumn(false);
        } else {
          setDisableCheckboxColumn(true);
        }
      } else {
        setSelectedIds([]);
        setSettingType(null);
        setCurrentSettingStatus(null);
      }

    } catch (error) {
      setSnackbar({
        open: true,
        message: error.response.data.message || "Something Went Wrong",
        severity: "error",
      })
    }
    setIsLoading(false);
  }
  const fetchAllUserDetails = async () => {
    try {
      const params = {
        status: 'active'
      }
      const respUsersDetails = await usersService.getAllUserDetails(params);
      const updatedUserDetails = respUsersDetails.data.data.users?.map(item => ({ ...item, name: `${item.firstName} ${item.lastName}` }))
      setUsersList(updatedUserDetails);
      setTotalUsersList(updatedUserDetails);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSettingTypeChange = (newSettingType) => {
    if (newSettingType !== settingType) {
      setSettingType(newSettingType);
      if (newSettingType === "selectedUsers") {
        setDisableCheckboxColumn(false);
      } else {
        setSelectedIds([]);
        setDisableCheckboxColumn(true);
      }
      setDisableSave(false);
    }
  }

  const saveRolloutSettings = async (updatedSettingType, userList = []) => {
    try {
      setIsLoading(true);
      const payload = {
        featureName: selectedOption,
        status: updatedSettingType,
        users: userList
      }
      await RolloutService.setRolloutSettings(payload);
      setCurrentSettingStatus(updatedSettingType);
      setSnackbar({
        open: true,
        message: "Rollout Settings has been updated.",
        severity: "success",
      });
      setDisableSave(true);
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.response.data.message || "Something Went Wrong",
        severity: "error",
      });
    }
    setIsLoading(false);
  }
  useEffect(() => {
    fetchAllUserDetails();
  }, []);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  useEffect(() => {
    fetchRolloutSettings();
  }, [selectedOption])
  const handleSearch = (event) => {
    console.log(event.target.value)
    setSearch(event.target.value);
    setUsersList(TotalusersList.filter(list=> list.firstName.trim()?.startsWith(event.target.value)|| list.email?.startsWith(event.target.value)) 
    )
  };
  return (
    <Box>
      <Box className="flex items-center justify-between">
        <Box className="flex items-center">
        <Typography variant="h1"  >
          Rollout Feature Settings
        </Typography>
        <Select
          value={selectedOption}
          className="ml-8"
          onChange={(e) => { setSelectedOption(e.target?.value) }}
        >
          {featureList.map(({ label, value }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
        </Box>
        <Typography variant="body2" fontWeight="bold" className="pl-5 flex items-center" >Status - {!settingStatus ?<CircularProgress size="17px" sx={{ml:2}}/>:settingStatus }</Typography>
      </Box>
      <Divider sx={{ marginBlock: "1em" }} />
      <Box display="flex" gap={2} justifyContent="space-between" className="items-center">
        <Box sx={{ display: 'flex', gap: '10px' }}>
        <TextInputComponent
            label="Search"
            variant="outlined"
            value={search}
            onChange={handleSearch}
          />
        </Box>
        
        <Box sx={{ display: 'flex', gap: '10px',height:'fit-content' }}>
          <Button
            onClick={() => handleSettingTypeChange("enabled")}
            variant={settingType === "enabled" ? "contained" : "outlined"}
          >
            Enable for All
          </Button>
          <Button
            onClick={() => handleSettingTypeChange("disabled")}
            variant={settingType === "disabled" ? "contained" : "outlined"}
          >
            Disable for All
          </Button>
          <Button
            onClick={() => handleSettingTypeChange("selectedUsers")}
            variant={settingType === "selectedUsers" ? "contained" : "outlined"}
          >
            Select User
          </Button>
          <Divider orientation="vertical" flexItem style={{ margin: '0 16px' }} />
          <Button variant="contained" disabled={disableSave} onClick={() => { saveRolloutSettings(settingType, selectedIds) }}>Save</Button>
        </Box>
      </Box>
      <Box mb={3} mt={2}>
        {usersList.length > 0 ? (
          <DataGrid
            rows={usersList}
            columns={columns}
            getRowId={(row) => row.userId}
            checkboxSelection={false}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[5, 10, 20, 50, 100]}
            isRowSelectable={() => settingType === "selectedUsers"}
          />
        ) : (
          <Typography variant="body1" align="center" sx={{ mt: 4 }}>
            No records found
          </Typography>
        )}
      </Box>
      {isLoading && (<Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>)}
      <AlertSnackbar
        open={snackbar.open}
        handleClose={handleCloseSnackbar}
        message={snackbar.message}
        severity={snackbar.severity}
      />
    </Box>

  )
}
export default RolloutFeaturePage;